import { AbstractControl } from '@angular/forms';

export const numberExists = (control: AbstractControl): { [key: string]: any } | null => {
    return {'numberExists': 'Number already Exists' };
}